<div class="success-container" *ngIf="status === 'success'">
    <div class="content">
        <img src="assets/images/success.svg" alt="Success illustration" class="illustration" />
        <p class="message">
            Your quotation has been successfully requested.<br />
            Our team will follow up with you shortly.
        </p>
        <p class="support">
            For further assistance, please contact our team.
        </p>
        <button class="home-btn" (click)="goHome()">Back to home page →</button>
    </div>
</div>
<div class="success-container" *ngIf="status === 'failed'">
    <div class="content">
        <img src="assets/images/error.svg" alt="Failed illustration" class="illustration" />
        <p class="message">
            We’re currently unable to provide coverage for your vehicle.<br />
            We apologise for any inconvenience.
        </p>
        <p class="support">
            For further assistance, please contact our team.
        </p>
        <button class="home-btn" (click)="goHome()">Back to home page →</button>
    </div>
</div>